import { NgModule } from '@angular/core';
import { RouterModule, type Routes } from '@angular/router';
import { MarketingCampaignEntryResolverService } from './marketing-campaign-entry-resolver.service';
import { MarketingCampaignResolverService } from './marketing-campaign-resolver.service';
import { MarketingCampaignRunResolverService } from './marketing-campaign-run-resolver.service';

const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./campaigns/campaigns.component').then(
        (mod) => mod.CampaignsComponent
      ),
  },
  {
    path: ':uid',
    resolve: {
      campaign: MarketingCampaignResolverService,
    },
    loadComponent: () =>
      import('./campaign/campaign.component').then(
        (mod) => mod.CampaignComponent
      ),
    children: [
      {
        path: 'settings',
        loadComponent: () =>
          import('./campaign-settings/campaign-settings.component').then(
            (mod) => mod.CampaignSettingsComponent
          ),
      },
      {
        path: 'steps',
        loadComponent: () =>
          import('./campaign-steps/campaign-steps.component').then(
            (mod) => mod.CampaignStepsComponent
          ),
      },
      {
        path: 'runs',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./campaign-run-list/campaign-run-list.component').then(
                (mod) => mod.CampaignRunListComponent
              ),
          },
          {
            path: ':uid',
            resolve: {
              campaignRun: MarketingCampaignRunResolverService,
            },
            loadComponent: () =>
              import('./campaign-run/campaign-run.component').then(
                (mod) => mod.CampaignRunComponent
              ),
          },
        ],
      },
      {
        path: 'entries',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './campaign-entry-list/campaign-entry-list.component'
              ).then((mod) => mod.CampaignEntryListComponent),
          },
          {
            path: ':uid',
            resolve: {
              campaignEntry: MarketingCampaignEntryResolverService,
            },
            loadComponent: () =>
              import('./campaign-entry/campaign-entry.component').then(
                (mod) => mod.CampaignEntryComponent
              ),
          },
        ],
      },
      {
        path: '',
        redirectTo: 'settings',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    MarketingCampaignResolverService,
    MarketingCampaignRunResolverService,
    MarketingCampaignEntryResolverService,
  ],
})
export class NgMarketingRoutingModule {}
